import Vue from 'vue'
import Child from './Child'

// Components that are registered globaly.
[
  Child,
].forEach(Component => {
  Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js